var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPayroll(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6073_287818",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6073_287818)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.6668 17.3334C17.5557 17.3334 16.6113 16.9445 15.8335 16.1667C15.0557 15.3889 14.6668 14.4445 14.6668 13.3334C14.6668 12.2223 15.0557 11.2778 15.8335 10.5C16.6113 9.72226 17.5557 9.33337 18.6668 9.33337C19.7779 9.33337 20.7224 9.72226 21.5002 10.5C22.2779 11.2778 22.6668 12.2223 22.6668 13.3334C22.6668 14.4445 22.2779 15.3889 21.5002 16.1667C20.7224 16.9445 19.7779 17.3334 18.6668 17.3334ZM9.3335 21.3334C8.60016 21.3334 7.97239 21.0723 7.45016 20.55C6.92794 20.0278 6.66683 19.4 6.66683 18.6667V8.00004C6.66683 7.26671 6.92794 6.63893 7.45016 6.11671C7.97239 5.59449 8.60016 5.33337 9.3335 5.33337H28.0002C28.7335 5.33337 29.3613 5.59449 29.8835 6.11671C30.4057 6.63893 30.6668 7.26671 30.6668 8.00004V18.6667C30.6668 19.4 30.4057 20.0278 29.8835 20.55C29.3613 21.0723 28.7335 21.3334 28.0002 21.3334H9.3335ZM12.0002 18.6667H25.3335C25.3335 17.9334 25.5946 17.3056 26.1168 16.7834C26.6391 16.2612 27.2668 16 28.0002 16V10.6667C27.2668 10.6667 26.6391 10.4056 26.1168 9.88337C25.5946 9.36115 25.3335 8.73337 25.3335 8.00004H12.0002C12.0002 8.73337 11.7391 9.36115 11.2168 9.88337C10.6946 10.4056 10.0668 10.6667 9.3335 10.6667V16C10.0668 16 10.6946 16.2612 11.2168 16.7834C11.7391 17.3056 12.0002 17.9334 12.0002 18.6667ZM26.6668 26.6667H4.00016C3.26683 26.6667 2.63905 26.4056 2.11683 25.8834C1.59461 25.3612 1.3335 24.7334 1.3335 24V9.33337H4.00016V24H26.6668V26.6667Z",
    fill: "#A1A1A1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayroll);
export default __webpack_public_path__ + "static/media/Payroll.f02a419293c6975edff7d58c21eaa910.svg";
export { ForwardRef as ReactComponent };